module.exports = __webpack_public_path__ + "static/csatPerformance-aa87397157049852406ae05747ef3166.png";